export const deleteOrder = async (
    orderID: string,
    token: string,
    value?: string | number,
    note?: string,
) => {
    try{
        console.log(`DeleteOrder deleting Order# ${orderID}, ${value}, ${note}`)

        const baseUrl = 'https://customer.hirsch.com/order/v2'
        const res = await fetch(baseUrl, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': btoa(`Bearer ${token}`)
            },
            body: JSON.stringify({
                id: orderID,
                code: value,
                note: note
            })
        })
        const json = await res.json();
        
        if (!res.ok) {
            throw new Error(json?.errorMessage || 'Failed to Delete Order')
        }

        return json;
    } catch (err: any) {
        throw err;
    }
};